import * as React from 'react';
import { Component } from 'react';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import {
  createPlanningLibraryItem,
  listPlanningLibraryItems,
  updatePlanningLibraryItem,
} from '../redux/actions/table/planning_library';
import PlanningLibraryItemForm from '../forms/planning_library_item/PlanningLibraryItemForm';

@mapStateToProps((state) => ({
  editor: state.table.planning_library.editor,
}))
class PlanningLibraryItemWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    const { editor } = this.props;
    const data = {
      ...formData,
      type: editor.type,
    };
    const action = editor.id
      ? updatePlanningLibraryItem(editor.id, data, editor.isSystem)
      : createPlanningLibraryItem(data, editor.isSystem);

    return validateForm(
      action.then(() => {
        listPlanningLibraryItems(editor.type, editor.isSystem);
        setNotification(
          __('planning-templates.notification.saved')
        );
        this.props.onClose();
      })
    );
  }

  render() {
    const { editor } = this.props;

    return (
      <PlanningLibraryItemForm
        title={
          editor.id
            ? __('planning-templates.editor.edit')
            : __('planning-templates.editor.create')
        }
        editing={Boolean(editor.id)}
        initialValues={editor.initialValues}
        onClose={this.props.onClose}
        onSubmit={this._handleSubmit}
      />
    );
  }
}

export default PlanningLibraryItemWizard;
